import {useIsMobile} from 'src/pages/route/hooks'

import {AdvertInfoDesktop} from './desktop'
import {AdvertInfoMobile} from './mobile'
import {AdvertModalProps} from './types'

type Props = {
  isOpened?: boolean
  onClose: VoidFunction
  content: AdvertModalProps['content']
}

function AdvertInfo({content, isOpened, onClose}: Props) {
  const isMobile = useIsMobile()
  const WebTipsModalComponent = isMobile ? AdvertInfoMobile : AdvertInfoDesktop

  if (Boolean(isOpened)) {
    return <WebTipsModalComponent content={content} onClose={onClose} />
  }

  return null
}

export default AdvertInfo
